/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Fmt_OpenInputs */

const en_vc_fmt_open = /** @type {(inputs: Vc_Fmt_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens`)
};

const zh_vc_fmt_open = /** @type {(inputs: Vc_Fmt_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以打开`)
};

/**
* | output |
* | --- |
* | "Opens" |
*
* @param {Vc_Fmt_OpenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_fmt_open = /** @type {((inputs?: Vc_Fmt_OpenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Fmt_OpenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_fmt_open(inputs)
	return zh_vc_fmt_open(inputs)
});
export { vc_fmt_open as "vc.fmt.open" }